<style lang="scss" scoped>
.filter {
    height: 56px;
    margin-bottom: 10px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid #cccccc;
    cursor: pointer;
    color: var(--dark);
    transition: border 0.15s, background 0.15s, color 0.15s;

    &:hover {
        color: var(--accent);
        border: 2px solid var(--accent);
        box-shadow: 0 0 20px -5px rgba(0, 0, 0, 0.2);
        text-decoration: none;
    }

    @media (min-width: 576px) {
        height: 80px;
    }
}

.row-xs-small {
    @media (max-width: 575.98px) {
        margin-right: -5px !important;
        margin-left: -5px !important;
    }
    .col-4 {
        @media (max-width: 575.98px) {
            padding-right: 5px !important;
            padding-left: 5px !important;
        }
    }
}
</style>

<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="mb-32 d-flex flex-wrap w-100">
                    <h3 v-html="title" class="title"></h3>
                </div>
                <div class="row row-xs-small mb-md-n24">
                    <div class="col-4 col-md-3 col-xl-2" v-for="(category, index) in categories" :key="index">
                        <a class="filter mb-md-24" :href="route('nl.activities', {'categories': category.slug})">
                            <p class="small" v-html="category.name"></p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pagePart.category-filter-row",

    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
        categories: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
    }
}
</script>